import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, catchError, of } from 'rxjs';
import { ServiceConstant } from '../utils/service-constant.util';

@Injectable({
  providedIn: 'root',
})
export class OrderService {
  httpClient = inject(HttpClient);
  constructor() {}

  getAllOrdersByTime(
    hours: any,
    pageLimit: number,
    lastEvaluateKey: string,
    status: string,
    orderType: string,
  ): Observable<any> {
    let url: string = '';
    if (status == '') {
      if (orderType == '') {
        url =
          ServiceConstant.apiUrl +
          `/restaurants/orders?delta_hours=` +
          hours +
          `&limit=` +
          pageLimit +
          `&last_evaluated_key=` +
          lastEvaluateKey;
      } else {
        url =
          ServiceConstant.apiUrl +
          `/restaurants/orders?delta_hours=` +
          hours +
          `&limit=` +
          pageLimit +
          `&last_evaluated_key=` +
          lastEvaluateKey +
          `&order_type=` +
          orderType;
      }
    } else {
      if (orderType == '') {
        url =
          ServiceConstant.apiUrl +
          `/restaurants/orders?delta_hours=` +
          hours +
          `&limit=` +
          pageLimit +
          `&last_evaluated_key=` +
          lastEvaluateKey +
          `&order_status=` +
          status;
      } else {
        url =
          ServiceConstant.apiUrl +
          `/restaurants/orders?delta_hours=` +
          hours +
          `&limit=` +
          pageLimit +
          `&last_evaluated_key=` +
          lastEvaluateKey +
          `&order_status=` +
          status +
          `&order_type=` +
          orderType;
      }
    }
    return this.httpClient.get(url).pipe(
      catchError((error) => {
        console.error('Get all orders sort by hours:', error);
        return of(error);
      }),
    );
  }

  getOrderById(id: any): Observable<any> {
    return this.httpClient.get(ServiceConstant.apiUrl + `/restaurants/orders/` + id).pipe(
      catchError((error) => {
        console.error('Get order by id:', error);
        return of(error);
      }),
    );
  }
}
